import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const getWizzardSimpleItem = createSelector(wizzardState, (wizzard) => wizzard.itemsSimple);
